"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Item = exports.ItemAttribute = void 0;
class ItemAttribute {
    constructor(attribute, amount) {
        this.attribute = attribute;
        this.amount = amount;
    }
}
exports.ItemAttribute = ItemAttribute;
class Item {
    constructor(name, type, minLevel, rarity, attributes = [], imageUrl, itemLevel, characterSkinOverrideKey) {
        this.name = name;
        this.type = type;
        this.minLevel = minLevel;
        this.rarity = rarity;
        this.attributes = attributes;
        this.imageUrl = imageUrl;
        this.itemLevel = itemLevel;
        this.characterSkinOverrideKey = characterSkinOverrideKey;
    }
}
exports.Item = Item;
